module.exports = __webpack_public_path__ + "img/info_5.b254035d.jpeg";